const settingsStrings = {
    group: {
        system: "Система",
        messages: "Сообщения",
        buyer: "Покупатель"
    }
}

export default settingsStrings;